/** Sunday footer: link groups are open from 720 px (a grid) and folded on a phone. */
const wide = matchMedia('(min-width: 720px)');
const sync = () => {
  for (const d of document.querySelectorAll('.sd-ftd')) d.open = wide.matches;
};
sync();
wide.addEventListener('change', sync);
